import { NJText } from '@engie-group/fluid-design-system-react';
import { UMR, UMStack } from '../../urbanmap/_components';
import { formatMetric } from './plans.data';
import type { DevelopmentPlan } from './plans.types';

function SummaryRow({ label, value, unit }: { label: string; value: string; unit?: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
      <div style={{ fontSize: 14, lineHeight: '20px', color: UMR.textStrong }}>{label}</div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <div style={{ fontSize: 16, lineHeight: '24px', fontWeight: 700, color: UMR.textStrong }}>{value}</div>
        {unit && <div style={{ fontSize: 12, lineHeight: UMR.lhXs, color: UMR.textMuted }}>{unit}</div>}
      </div>
    </div>
  );
}

/** Résumé du plan ouvert, au style du bloc « Résumé » des sélections UrbanMap. */
export function PlanSummary({ plan }: { plan: DevelopmentPlan }) {
  return (
    <section aria-label={`Résumé du plan ${plan.name}`} style={{
      display: 'flex', flexDirection: 'column', gap: 12, padding: '8px 16px',
      background: UMR.grey100, borderRadius: 8, border: `1px solid ${UMR.border}`, fontFamily: UMR.font,
    }}>
      <NJText scale="sm">Résumé simulé — pas un calcul UrbanMap</NJText>
      <UMStack gap={16}>
        <SummaryRow label="Nombre de bâtiments" value={formatMetric(plan.buildingCount)} />
        <SummaryRow label="Conso totale" value={formatMetric(plan.consumption)} unit="GWh/an" />
        <SummaryRow label="Longueur de réseau" value={plan.networkLength === null ? '—' : formatMetric(plan.networkLength)}
          unit={plan.networkLength === null ? 'tracé à valider' : 'km'} />
      </UMStack>
    </section>
  );
}

/** Indicateurs PO : nombre de bâtiments, consommation totale, longueur du réseau. */
export function PlanMetrics({ plan }: { plan: DevelopmentPlan }) {
  const items = [
    { label: 'Bâtiments', value: formatMetric(plan.buildingCount) },
    { label: 'Conso simulée', value: `${formatMetric(plan.consumption)} GWh/an` },
    { label: 'Réseau simulé', value: plan.networkLength === null ? '—' : `${formatMetric(plan.networkLength)} km` },
  ];
  return (
    <dl className="pnv2-dp-metrics">
      {items.map((m) => (
        <div key={m.label}>
          <dt><NJText as="span" scale="xs" className="pnv2-dp-muted">{m.label}</NJText></dt>
          <dd><NJText as="strong" scale="sm">{m.value}</NJText></dd>
        </div>
      ))}
    </dl>
  );
}
